export const providerAuthKeys = {
  all: ['providerAuth'] as const,
  me: () => [...providerAuthKeys.all, 'me'] as const,
}

export const queueKeys = {
  all: ['queue'] as const,
  list: () => [...queueKeys.all, 'list'] as const,
}

export const visitKeys = {
  all: ['visit'] as const,
  detail: (id: string) => [...visitKeys.all, 'detail', id] as const,
}

export const recordingKeys = {
  all: ['recordings'] as const,
  list: (filters?: { status?: string }) =>
    [...recordingKeys.all, 'list', filters] as const,
  notes: (recordingId: string) =>
    [...recordingKeys.all, 'notes', recordingId] as const,
}

export const documentationKeys = {
  all: ['documentation'] as const,
  suggestCodes: (visitId: string) =>
    [...documentationKeys.all, 'suggest-codes', visitId] as const,
  treatmentPlan: (visitId: string) =>
    [...documentationKeys.all, 'treatment-plan', visitId] as const,
}

export const patientKeys = {
  all: ['patients'] as const,
  list: () => [...patientKeys.all, 'list'] as const,
  search: (query: string) => [...patientKeys.all, 'search', query] as const,
  detail: (id: string) => [...patientKeys.all, 'detail', id] as const,
}

export const onboardingKeys = {
  all: ['onboarding'] as const,
  progress: () => [...onboardingKeys.all, 'progress'] as const,
  stripeStatus: () => [...onboardingKeys.all, 'stripe-status'] as const,
  slugAvailability: (slug: string) =>
    [...onboardingKeys.all, 'slug-available', slug] as const,
}

export const settingsKeys = {
  all: ['settings'] as const,
  providerProfile: () => [...settingsKeys.all, 'provider-profile'] as const,
  practiceProfile: () => [...settingsKeys.all, 'practice-profile'] as const,
  visitTypes: () => [...settingsKeys.all, 'visit-types'] as const,
}

export const availabilityKeys = {
  all: ['availability'] as const,
  current: () => [...availabilityKeys.all, 'current'] as const,
}

export const paymentsKeys = {
  all: ['payments'] as const,
  summary: () => [...paymentsKeys.all, 'summary'] as const,
  history: (months: number) => [...paymentsKeys.all, 'history', months] as const,
}
